import { Constants, Enums, Tools } from "../utils";
import axios from "axios";

const request = axios.create();

request.interceptors.request.use(async (config) => {
  const token = Tools.storage.getItem(Enums.storageKeys.token);

  config.baseURL = Constants.Project.baseUrl;
  config.params = config.params || {};
  config.params.applicationPublicKey = Constants.Project.publicKey;

  if (!!token) config.headers.Authorization = `Bearer ` + token;

  if (config.url.includes(":userUuid")) {
    config.url = config.url.replace(
      ":userUuid",
      Tools.storage.getItem(Enums.storageKeys.userUuid)
    );
  }

  return config;
});

export default request;
